<template>
  <div class="job-sync-dashboard">
    <p class="description">
      Sync unmapped ServiceM8 jobs that are assigned to a mapped queue into {{ brand.agencyName }} opportunities.
      Requires Job / Opportunity Sync enabled with ServiceM8 → {{ brand.agencyName }} or Both directions.
    </p>

    <div class="sync-controls">
      <label>
        Jobs to scan:
        <select v-model="limit" class="select-field" :disabled="syncing">
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
        </select>
      </label>
      <button @click="runSync" class="btn-sync" :disabled="syncing">
        {{ syncing ? 'Syncing...' : 'Sync Jobs to Opportunities' }}
      </button>
    </div>

    <div v-if="result" class="sync-result" :class="{ error: result.errors > 0 }">
      <p><strong>Synced:</strong> {{ result.synced }}</p>
      <p><strong>Skipped:</strong> {{ result.skipped }}</p>
      <p><strong>Errors:</strong> {{ result.errors }}</p>
    </div>

    <p v-if="error" class="error-message">{{ error }}</p>
  </div>
</template>

<script>
import { brandMixin } from '../brandMixin'

export default {
  name: 'JobSyncDashboard',
  mixins: [brandMixin],
  data() {
    return {
      limit: 50,
      syncing: false,
      result: null,
      error: null,
    }
  },
  methods: {
    async runSync() {
      this.syncing = true;
      this.error = null;
      this.result = null;
      try {
        const ssoToken = await this.getSSOToken();
        const response = await fetch('/servicem8/sync/jobs', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-sso-token': ssoToken,
          },
          body: JSON.stringify({ limit: this.limit }),
        });
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.error || data.message || 'Sync failed');
        }
        this.result = data;
      } catch (err) {
        this.error = err instanceof Error ? err.message : 'Sync failed';
      } finally {
        this.syncing = false;
      }
    },
    async getSSOToken() {
      return await new Promise((resolve) => {
        window.parent.postMessage({ message: "REQUEST_USER_DATA" }, "*");
        window.addEventListener("message", ({ data }) => {
          if (data.message === "REQUEST_USER_DATA_RESPONSE") {
            resolve(data.payload);
          }
        });
      });
    },
  },
}
</script>

<style scoped>
.job-sync-dashboard {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.description {
  color: #666;
  margin: 0;
  line-height: 1.5;
}

.sync-controls {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.select-field {
  margin-left: 8px;
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.btn-sync {
  padding: 10px 20px;
  background: #24ACFE;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
}

.btn-sync:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.sync-result {
  padding: 16px;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 6px;
}

.sync-result.error {
  background: #fef2f2;
  border-color: #fecaca;
}

.sync-result p {
  margin: 4px 0;
}

.error-message {
  color: #b91c1c;
  margin: 0;
}
</style>
